<template>
  <div class="library-form-match-item">
    <round-button-with-icon icon="music-note" class="library-icon" />
    <library-track :track="track" />
    <trash-button-expanding @click="deleteMatch" />
  </div>
</template>
<script>
import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";
import LibraryTrack from "../../ListItems/Library/LibraryTrack.vue";
import TrashButtonExpanding from "../TrashButtonExpanding.vue";
export default {
  methods: {
    deleteMatch() {
      this.$emit("delete-match");
    },
  },
  components: {
    RoundButtonWithIcon,
    LibraryTrack,
    TrashButtonExpanding,
  },
  emits: ["delete-match"],
  props: ["track"],
};
</script>
<style scoped>
.library-form-match-item {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding-top: 5px;
  height: 35px;
}

.library-icon {
  margin-right: 10px;
}
</style>
